/**
 * Sdílená mřížka záhlaví a řádků položek dokladu.
 * Pořadí: položka (nejširší), množství, MJ, cena za MJ, DPH, celkem, odebrat.
 * Úchyt pro přesun sedí mimo mřížku v levém okraji.
 */
export const itemGridClass = (isVatPayer: boolean) =>
  isVatPayer
    ? 'grid w-full items-start gap-1.5 grid-cols-[minmax(160px,1fr)_60px_56px_112px_76px_100px_28px]'
    : 'grid w-full items-start gap-1.5 grid-cols-[minmax(160px,1fr)_60px_56px_120px_108px_28px]'

/** Minimální šířka tabulky položek, pod ní se tabulka posouvá vodorovně. */
export const itemGridMinWidth = (isVatPayer: boolean) => (isVatPayer ? 'min-w-[620px]' : 'min-w-[540px]')
